import { supabase } from "./supabaseClient";

export const fetchQuestions = async (quizId) => {
	try {
		const { data, error } = await supabase
			.from("questions")
			.select("*")
			.eq("quiz_id", quizId)
			.order("order");

		if (error) throw error;

		return data;
	} catch (error) {
		console.error("Error fetching questions by category:", error);
		return {};
	}
};
